import {
  SCOUT_NATIVE_TEXT_SYNC_THRESHOLD_BYTES,
  SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES,
  SCOUT_TEXT_EXTRACTION_OFFICE_MAX_BYTES,
} from "./attachmentLimits";

export type SupportedTextExtractionFormat = {
  extensions: readonly string[];
  mimeTypes: readonly string[];
  /** Max upload size for Scout LARGE_FILE_EXTRACTION path. */
  maxUploadBytes: number;
  /** Files at or below this size sync-extract on the NATIVE path. */
  nativeSyncThresholdBytes: number;
};

export const SUPPORTED_TEXT_EXTRACTION_FORMATS: readonly SupportedTextExtractionFormat[] = [
  {
    extensions: ["docx"],
    mimeTypes: ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
    maxUploadBytes: SCOUT_TEXT_EXTRACTION_OFFICE_MAX_BYTES,
    nativeSyncThresholdBytes: SCOUT_NATIVE_TEXT_SYNC_THRESHOLD_BYTES,
  },
  {
    extensions: ["xlsx"],
    mimeTypes: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
    maxUploadBytes: SCOUT_TEXT_EXTRACTION_OFFICE_MAX_BYTES,
    nativeSyncThresholdBytes: SCOUT_NATIVE_TEXT_SYNC_THRESHOLD_BYTES,
  },
  {
    extensions: ["pptx"],
    mimeTypes: ["application/vnd.openxmlformats-officedocument.presentationml.presentation"],
    maxUploadBytes: SCOUT_TEXT_EXTRACTION_OFFICE_MAX_BYTES,
    nativeSyncThresholdBytes: SCOUT_NATIVE_TEXT_SYNC_THRESHOLD_BYTES,
  },
  {
    extensions: ["xml"],
    mimeTypes: ["application/xml", "text/xml"],
    maxUploadBytes: SCOUT_TEXT_EXTRACTION_OFFICE_MAX_BYTES,
    nativeSyncThresholdBytes: SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES,
  },
  {
    extensions: ["csv"],
    mimeTypes: ["text/csv", "application/csv"],
    maxUploadBytes: SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES,
    nativeSyncThresholdBytes: SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES,
  },
  {
    extensions: ["tsv"],
    mimeTypes: ["text/tab-separated-values"],
    maxUploadBytes: SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES,
    nativeSyncThresholdBytes: SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES,
  },
] as const;

function normalizeExtension(extension: string | undefined): string | undefined {
  if (extension === undefined) {
    return undefined;
  }
  const trimmed = extension.trim().toLowerCase();
  return trimmed.startsWith(".") ? trimmed.slice(1) : trimmed;
}

export function findSupportedTextExtractionFormat(input: {
  mediaType?: string;
  extension?: string;
}): SupportedTextExtractionFormat | undefined {
  const mime = input.mediaType?.trim().toLowerCase();
  const ext = normalizeExtension(input.extension);

  for (const format of SUPPORTED_TEXT_EXTRACTION_FORMATS) {
    if (mime && format.mimeTypes.includes(mime)) {
      return format;
    }
    if (ext && format.extensions.includes(ext)) {
      return format;
    }
  }

  return undefined;
}

export function isEncampAiTextFormat(input: { mediaType?: string; extension?: string }): boolean {
  return findSupportedTextExtractionFormat(input) !== undefined;
}
